<template>
  <div class="exchange">
    <CommonHeader>
      {{ $t('currency_rules.currency_exchange.name') }}
      <div
        v-if="$route.query.type !== 'me'"
        slot="right"
        class="primary"
        @click="showMeExchange"
      >
        我的兑换
      </div>
    </CommonHeader>
    <div class="goods-list">
      <div
        v-for="(item,index) in goods"
        :key="index"
        class="goods"
        @click="exchange(item.id)"
      >
        <img :src="item.icon" alt="">
        <div class="goods-name">{{ item.name }}</div>
        <div class="goods-score">
          <span class="score">{{ item.score }} <span class="unit">{{ $t('currency.unit') }}</span></span>
          <!-- <button
            class="follow"
            @click="exchange(item.id)"
          >
            {{ $t('currency_rules.exchange') }}
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { getCurrencyGoodsExchange, getCurrencyGoods, getMyCurrencyGoodsExchange } from '@/api/currency'
  export default {
    data () {
      return {
        goods: [],
      }
    },
    watch: {
      '$route' (to, from) {
        // 对路由变化作出响应...
        this.getGoods()
      },
    },
    mounted () {
      this.getGoods()
    },
    methods: {
      getGoods () {
        let api = getCurrencyGoods
        if (this.$route.query.type === 'me') api = getMyCurrencyGoodsExchange
        api().then(res => {
          this.goods = [...res.data]
        })
      },
      exchange (id) {
        if (this.$route.query.type === 'me') return
        Dialog.confirm({
          title: this.$t('currency_rules.currency_exchange.ensure'),
          showCancelButton: true,
        }).then(res => {
          getCurrencyGoodsExchange({ id }).then(res => {
            this.$Message.success(this.$t('currency_rules.currency_exchange.success'))
          })
        })
      },
      showMeExchange () {
        this.$router.push({ path: '/currency/exchange?type=me' })
      },
    },

  }
</script>

<style lang="less" scoped>
.exchange {
  background-color: #fff;
  border-radius:6px;
  .goods-list {
    display: flex;
    padding: 15px;
    flex-wrap: wrap;
    .goods {
      margin: 15px;
      padding-bottom: 36px;
      width: 330px;
      background-color: #F7F7F7;
      img {
        width: 100%;
        height: 330px;
        width: 330px;
        border-radius:6px;
      }
      .goods-name {
        color: @tool-bar-bg;
        font-size:28px;
        margin: 15px 15px;
      }
    }
  }
  .goods-score {
    display: flex;
    margin: 0 15px;
    justify-content: space-between;
  }
  .follow {
    padding: 6px 23px;
    background-color: #00AEEF;
    font-size:22px;
    color: #fff;
  }
  .score {
    color: #D52B1E;
    margin-right: 10px;
    .unit {
      color: #ccc;
    }
  }
}
</style>
